import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material'
import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next';
import { msalResult } from '../../authConfig';

export const Err = ({isOpen}: any) => {

    const [open, setOpen] = useState(isOpen);
    const { t } = useTranslation();

    // MSAL is initialized in App.tsx, no need to re-initialize here
    
      const msalInstance = msalResult?.instance;

    const handleLogout = () => { 
      setOpen(false);    
      
      if (msalInstance) {
        msalInstance.logoutRedirect();
      }
    }
  
    return (
      <div>
        <Dialog
          open= {open}
          onClose={handleLogout }
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
            <DialogTitle id="alert-dialog-title">
                Session Update
            </DialogTitle> 
        
          <DialogContent>
              <DialogContentText id="alert-dialog-description">
                  Session Expired
                  <br></br>
              </DialogContentText>
          </DialogContent>
  
          <DialogActions>
                <Button onClick={handleLogout} autoFocus> Logout </Button> 
          </DialogActions>
          
        </Dialog>
      </div>
    )
}
